import type { Face } from '@strategy4kids/game-engine';

/**
 * A small printed mark for every tile, so colour is never the only cue (the tile art is coloured: red characters, green bamboo,
 * blue dots) and the tile stays readable when the device has no font for the Unicode Mahjong glyphs. Suits get a shape, honours a letter.
 */
const SUIT_MARK: Record<string, string> = { dots: '●', bamboo: '▮', characters: '◆' };
const WIND_LETTER: Record<string, string> = { east: 'E', south: 'S', west: 'W', north: 'N' };
const DRAGON_LETTER: Record<string, string> = { red: 'R', green: 'G', white: 'W' };

export function tileMark(face: Face): string {
  const [kind, which] = face.split('-') as [string, string];
  if (kind in SUIT_MARK) return `${which}${SUIT_MARK[kind]}`;
  if (kind === 'wind') return WIND_LETTER[which] ?? '';
  if (kind === 'dragon') return DRAGON_LETTER[which] ?? '';
  if (kind === 'flower') return '✿';
  return '☀';
}

/** Tile ink by suit, with the mark above as the second cue. */
export function tileInk(face: Face): string {
  const kind = face.split('-')[0];
  if (kind === 'bamboo') return 'text-green-700';
  if (kind === 'dots') return 'text-blue-700';
  if (kind === 'characters' || kind === 'dragon') return 'text-red-700';
  if (kind === 'flower' || kind === 'season') return 'text-fuchsia-700';
  return 'text-slate-900';
}
